import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import 'moment/locale/pl';
import moment from 'moment';
import 'antd/dist/antd.css';

import { Footer, Header } from '../index';
import { MassListContextProvider } from '../../MassList/MassListContext';

import styles from './MassOfferingsLayout.module.scss';

moment.locale('pl');

const MassOfferingsLayout = ({ preselectedDate, children }) => (
  <>
    <div className={classNames('app h-100 d-flex flex-column', styles.self)}>
      <Header description="Wsparcie parafii - ofiara online" />

      <main className="container-lg flex-grow-1 flex-shrink-0 d-flex flex-column mt-5 justify-content-center">
        <MassListContextProvider preselectedDate={preselectedDate}>
          {children}
        </MassListContextProvider>
      </main>

      <div className={styles.footerWrapper}>
        <Footer isWhite />
      </div>
    </div>
  </>
);

MassOfferingsLayout.propTypes = {
  children: PropTypes.node,
  preselectedDate: PropTypes.string,
};

export default MassOfferingsLayout;
